import React from "react";
import "../../styles/Player.css";
function Volume({ onClick, isMuted, value, onChange }) {
  return (
    <div className="z-40 flex items-center w-[60%] mb-6 space-x-4">
      <div
        onClick={onClick}
        className="text-[20px] text-slate-300/60 active:bg-slate-300/10"
      >
        {value === 0 ? (
          <i className="bi-volume-mute"></i>
        ) : (
          <i className="bi-volume-up"></i>
        )}
      </div>

      <div className="flex w-full">
        <input
          type="range"
          name=""
          id=""
          className="h-[4px] bg-slate-200/30 volume-slider w-full"
          min={0}
          max={1}
          step={0.1}
          value={value}
          onChange={onChange}
          style={{
            background: `linear-gradient(90deg, rgb(226 232 240 / 0.5) ${Math.floor(
              value * 100
            )}%, rgb(226 232 240 / 0.1)  ${Math.floor(value * 100)}%)`,
          }}
        />
      </div>
    </div>
  );
}

export default Volume;
